/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ plan: NonNullable<unknown>, price: NonNullable<unknown> }} Common_Pricing_Payment_ForInputs */

const en_common_pricing_payment_for = /** @type {(inputs: Common_Pricing_Payment_ForInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.plan} — ${i?.price}`)
};

const zh_common_pricing_payment_for = /** @type {(inputs: Common_Pricing_Payment_ForInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.plan} — ${i?.price}`)
};

/**
* | output |
* | --- |
* | "{plan} — {price}" |
*
* @param {Common_Pricing_Payment_ForInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_pricing_payment_for = /** @type {((inputs: Common_Pricing_Payment_ForInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Pricing_Payment_ForInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_pricing_payment_for(inputs)
	return zh_common_pricing_payment_for(inputs)
});
export { common_pricing_payment_for as "common.pricing.payment_for" }